export const RESET_ROLES = "RESET_ROLES";
export const RESET_ROLE = "RESET_ROLE";
export const RESET_ERROR = "RESET_ERROR";

export const GET_ROLES = "GET_ROLES";
export const SET_ROLES = "SET_ROLES";

export const API_ERROR = "ROLES_API_ERROR";

export const GET_ROLE = "GET_ROLE";
export const SET_ROLE = "SET_ROLE";

export const EDIT_ROLE = "EDIT_ROLE";
export const EDIT_ROLE_SUCCESS = "EDIT_ROLE_SUCCESS";

export const CREATE_ROLE = "CREATE_ROLE";
export const CREATE_ROLE_SUCCESS = "CREATE_ROLE_SUCCESS";

export const DELETE_ROLE = "DELETE_ROLE";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";
